import * as React from "react";
import i18n from "i18n";
import { observer } from "mobx-react";
import {
  withStyles,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@material-ui/core";

import { WBSStore } from "../../WBSStore";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";

const styles = (theme) => ({
  dialogBox: {
    "& > div > div": {
      backgroundColor: "#FFF",
      borderRadius: "8px",
    },
  },
  dialogTitle: {
    backgroundColor: "#FFF",
    borderBottom: "none",
    paddingBottom: "12px",
    "& h6": {
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "23px",
      color: "#424242",
    },
  },
  dialogContent: {
    backgroundColor: "#FFF",
    paddingTop: "12px",
    "& p": {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "19px",
      color: "#212121",
    },
  },
  dialogActions: {
    backgroundColor: "#FFF",
  },
  btnCancel: {
    color: "#757575",
    textTransform: "uppercase" as any,
  },
  btnExclude: {
    color: "#D73912",
    textTransform: "uppercase" as any,
  },
});
type IProps = {
  classes: any;
};
@observer
class ChangeQuantityModal extends React.Component<IProps> {
  // const ChangeQuantityModal = (props) => {

  addQuantityFromTakeOffItem() {
    ModelMapStore.addQuantityFromTakeOffItem(WBSStore.tempLineAddQuantity);
    this.achange(false);
  }

  achange(value) {
    WBSStore.changeFunction(value);
  }
  Transition = (props) => {
    return <Slide direction="up" {...props} />;
  };
  render() {
    const { classes } = this.props;

    return (
      <Dialog
        open={WBSStore.showAlertQuantityModal}
        TransitionComponent={this.Transition}
        keepMounted
        onClose={() => this.achange(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        className={classes.dialogBox}
      >
        <DialogTitle
          id="alert-dialog-slide-title"
          className={classes.dialogTitle}
        >
          {i18n.modelMaps.modalExcludeFormula.title}
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText id="alert-dialog-slide-description">
            {i18n.modelMaps.modalExcludeFormula.text_01}
            <br /> <strong>{i18n.modelMaps.modalExcludeFormula.text_02}</strong>
            {i18n.modelMaps.modalExcludeFormula.text_03}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={() => this.achange(false)}
            className={classes.btnCancel}
          >
            {i18n.modelMaps.modalExcludeFormula.cancel}
          </Button>
          <Button
            onClick={() => this.addQuantityFromTakeOffItem()}
            className={classes.btnExclude}
          >
            {i18n.modelMaps.modalExcludeFormula.exclude}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(ChangeQuantityModal);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/ChangeQuantityModal.tsx